import React, { useCallback } from 'react';
import { GoogleMap, GoogleMapProps, LoadScriptNext, Marker, MarkerClusterer } from '@react-google-maps/api';
import { MapMarker, MapMarkerProps } from './MapMarker';
import { ClustererOptions } from '@react-google-maps/marker-clusterer';

export interface MapWrapperProps extends GoogleMapProps {
	apiKey: string;
	id: string;
	zoom?: number;
	style?: { width: string; height: string };
	cluster?: boolean;
	clusterOptions?: ClustererOptions;
	children: React.ReactElement<MapMarkerProps>[];
}

export const MapWrapper: React.FC<MapWrapperProps> = (props) => {
	const { apiKey, id, zoom = 4, center = null, style, options = {}, cluster = false, clusterOptions = {}, children } = props;

	const centerAndZoomOnMarkers = (markers: any, map: google.maps.Map) => {
		const bounds = new window.google.maps.LatLngBounds();

		markers.forEach((marker) => {
			if (marker.type === Marker) {
				bounds.extend(new window.google.maps.LatLng(marker.props.position.lat, marker.props.props.position.lng));
			}
			if (marker.type === MapMarker) {
				bounds.extend(new window.google.maps.LatLng(marker.props.content.properties.latitude, marker.props.content.properties.longitude));
			}
		});

		map.fitBounds(bounds);
	};

	const onLoad = useCallback(
		function callback(map: google.maps.Map) {
			if (!center) centerAndZoomOnMarkers(children, map);
		},
		[center, children],
	);

	return (
		<>
			<LoadScriptNext id={id} googleMapsApiKey={apiKey}>
				<GoogleMap id="marker-example" mapContainerStyle={style} zoom={zoom} center={center} onLoad={onLoad} options={options}>
					{!cluster && children}
					{cluster && (
						<MarkerClusterer options={clusterOptions}>
							{(clusterer) => (
								<>
									{children.map((child: React.ReactElement<MapMarkerProps>) => {
										const markerProps = { ...child.props, clusterer };

										return (
											<MapMarker key={child.key} {...markerProps}>
												{child.props.children}
											</MapMarker>
										);
									})}
								</>
							)}
						</MarkerClusterer>
					)}
				</GoogleMap>
			</LoadScriptNext>
		</>
	);
};
